module.exports = __webpack_public_path__ + "img/lFwdH.101d933d.svg";